import { render } from "./VUEModal.vue?vue&type=template&id=3496d742"
import script from "./VUEModal.vue?vue&type=script&lang=js"
export * from "./VUEModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__